import { render } from "./App.vue?vue&type=template&id=14086190"
const script = {}

import "./App.vue?vue&type=style&index=0&id=14086190&lang=scss"
script.render = render

export default script